require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-calculators-test-banzai-calculator.json") })
        }
      }, "path---es-calculators-test-banzai-calculator");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-calculators-test-banzai-calculator!./.cache/json/es-calculators-test-banzai-calculator.json
// module id = 2532
// module chunks = 231608221292675